import React, { useRef } from "react";
import { Dialog, DialogActions, DialogContent, Grid } from "@mui/material";
import { Button, TextField, Alert } from "@curves/ui-base";
import GradientColorHeader from "@icoach/components/dialog/GradientColorHeader";
import { isFunction, refIsRequiredError } from "@util/utils";
import useTemporaryApi from "@apis/useTemporaryApi";

const AddTemporaryDialog = React.forwardRef((props, ref) => {
	const { onClose: onCloseProps, open, sourceData = { list: [], note: "", type: null }, refresh: refreshProps } = props;
	if (!open) return null;
	
	const { postTemporaryOverviewApi } = useTemporaryApi();
	const folderRef = useRef(null);

	const len = sourceData.list.length;
	const handleCloseOnClick = () => {
		onCloseProps(null);
	};

	const handleSendOnClick = e => {
		if (!refIsRequiredError(folderRef)) {
			const title = folderRef.current.getResult() || "";
			const params = {
				name: title,
				customerType: sourceData.type,
				note: sourceData.note,
				targetIDs: [...sourceData.list],
			};

			addTemporariesDataApi(params);
		}
	};

	const addTemporariesDataApi = async params => {
		const resp = await postTemporaryOverviewApi(params);
		if (resp) {
			isFunction(refreshProps) && refreshProps();
            onCloseProps(null);
		} else {
			console.error(resp);
		}
	};

	return (
		<Dialog open={open} fullWidth>
			<GradientColorHeader onClose={handleCloseOnClick}>新增暫存清單</GradientColorHeader>
			<DialogContent>
				<Grid container>
					<Grid item xs={12}>
						<TextField ref={folderRef} label="名單標題" direction={"row"} fullWidth required />
					</Grid>
					<Grid item xs={12}>
						{open && (
							<Alert color="info" severity="info" variant="filled" className="my-3">
								{`篩選條件: ${sourceData.note}`}
								<br />
								選取 {len} 筆資料
							</Alert>
						)}
					</Grid>
				</Grid>
			</DialogContent>
			<DialogActions>
				<Button onClick={handleSendOnClick} color="secondary" variant="contained">
					確認
				</Button>
			</DialogActions>
		</Dialog>
	);
});

export default AddTemporaryDialog;
